module.exports = __webpack_public_path__ + "components/outside-promo-page/static/menu-d25655f7bc71a5882967cda6eae7f45c.svg";